// Fetches the app for a visitor who was sent the landing page without it.
//
// The landing page needs none of the app – twenty-odd scripts and well over a
// megabyte – but used to wait for all of it before its own scripts ran or any
// of its buttons answered. routes/home.js now leaves those tags out for a
// visitor with no session and lists their addresses in window.APP_SCRIPTS;
// this brings them in without holding the page up:
//
//   - straight away, when the address carries something only the app can act
//     on (a failed BlueAcorn sign-in, say);
//   - the moment a sign-in or sign-up button is pressed;
//   - otherwise once the page has finished loading and the browser is idle, so
//     that by the time one of those buttons is pressed the app is usually there.
//
// The files themselves are usually already downloaded by then: home.js also
// asks for them from the head as low-priority preloads, which fetch without
// running anything. This file decides when they run.
//
// A button pressed before it arrives is remembered by the inline script above
// #landing-view and answered by app.js (answerEarlyLandingTap) when it does.
(function () {
    'use strict';

    const scripts = Array.isArray(window.APP_SCRIPTS) ? window.APP_SCRIPTS : [];
    if (!scripts.length) return;

    // The classic page: every script in the HTML, as a signed-in teacher gets
    // it. Where to go when fetching them here has failed.
    const CLASSIC_URL = '/?app=1';

    let started = false;
    let failed = false;

    function loadApp() {
        if (started) return;
        started = true;
        for (const src of scripts) {
            const s = document.createElement('script');
            s.src = src;
            // Fetched together, run in the order listed – which the app
            // depends on, each file reading globals the ones before it set.
            s.async = false;
            s.onerror = onError;
            document.body.appendChild(s);
        }
    }

    // One file missing leaves the app half-built, and running the list again
    // would run the files that did arrive twice. So nothing is retried here:
    // the visitor carries on reading, and if they have pressed a button, or
    // press one later, they are taken to the page that loads it the plain way.
    function onError() {
        if (failed) return;
        failed = true;
        if (window.earlyLandingAction) window.location.assign(CLASSIC_URL);
    }

    const wantsApp = (target) => target && target.closest && target.closest('[data-landing-action]');

    // pointerdown as well as click: it comes first, and on a slow connection
    // the head start is worth having.
    for (const type of ['pointerdown', 'click']) {
        document.addEventListener(type, (e) => {
            if (!wantsApp(e.target)) return;
            if (failed) return window.location.assign(CLASSIC_URL);
            loadApp();
        }, true);
    }

    // Tags an ad or a share adds to the address, which the landing page can be
    // read with. Anything else is the app's business, and it should not wait.
    const AD_PARAM = /^(utm_[a-z_]+|fbclid|gclid|gbraid|wbraid|msclkid|ttclid|li_fat_id|igshid|mc_[a-z]+)$/i;
    let appParam = false;
    try {
        for (const key of new URLSearchParams(window.location.search).keys()) {
            if (!AD_PARAM.test(key)) appParam = true;
        }
    } catch { appParam = true; }
    if (appParam || window.location.hash) return loadApp();

    // Someone who has asked their browser to save data gets the app when they
    // ask for it and not before.
    if (navigator.connection && navigator.connection.saveData) return;

    function whenIdle() {
        if ('requestIdleCallback' in window) window.requestIdleCallback(loadApp, { timeout: 3000 });
        else setTimeout(loadApp, 1200);
    }
    if (document.readyState === 'complete') whenIdle();
    else window.addEventListener('load', whenIdle, { once: true });
})();
